module.exports = __webpack_public_path__ + "img/LightRain.dfc33140.png";